import ReactRenderer from "modules/_react-renderer";

import Tool from "./js/Tool";

ReactRenderer.registerComponent('SustainabilityTool', Tool);